import { Navigate, Outlet, useParams } from 'react-router-dom';
import { MODULE_LABELS, ROUTES } from '@/app/routes';
import { AppTopHeader } from './AppTopHeader';
import styles from './FormShell.module.scss';

// Shell for full-page forms: the app top bar and nothing else; the form owns the rest.
export const FormShell = () => {
  const { module } = useParams();

  // Same guard as WorkspaceShell; a global form (no `:module` segment) skips it.
  if (module !== undefined && !MODULE_LABELS[module]) return <Navigate to={ROUTES.home} replace />;

  return (
    <div className={styles.shell}>
      <AppTopHeader />
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};
